module.exports = __webpack_public_path__ + "media/components/country-flag/static/sx-cdf899a3acf7a8011b8f507f58ec9a06.svg";